// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_TPTITULO = {
  APagar: 'FIN_TPTITULO1',
  AReceber: 'FIN_TPTITULO2',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_TPTITULO1: 1,
    FIN_TPTITULO2: 2
  }
}
